type Props = {
  onlyFreeProducts: boolean;
  defaultPaymentMethod: {
    card: unknown | null;
  } | null;
  useDifferentPaymentMethod: boolean;
};

const isCreditCardRequired = ({
  onlyFreeProducts,
  defaultPaymentMethod,
  useDifferentPaymentMethod,
}: Props): boolean => {
  if (onlyFreeProducts) {
    return false;
  }

  if (defaultPaymentMethod?.card && !useDifferentPaymentMethod) {
    return false;
  }

  return true;
};

export default isCreditCardRequired;